import { useEffect } from 'react';
import { UMapBase } from '@uofu-uss-gis/ui-react';
import MyClassesPanel from './components/MyClasses/MyClassesPanel';
import MyClassesButton from './components/MyClasses/MyClassesButton';
import MyClassesPins from './components/MyClasses/MyClassesPins';
import AuthenticatedHeader from './components/Header/AuthenticatedHeader';
import ClassMapSidebar from './components/ClassMapSidebar/ClassMapSidebar';
import MobileAppControls from './components/MobileAppControls';
import { useAuthStore } from './store/authStore';
import { loadOidcService, shouldBypassOidc } from './services/oidcLoader';

const isLocalMode = shouldBypassOidc();

function App() {
  const { checkAuth } = useAuthStore();

  // Check auth status after USS OIDC finishes loading
  useEffect(() => {
    const runAuthCheck = async () => {
      if (isLocalMode) {
        await checkAuth({ silent: true });
        return;
      }

      const oidcService = await loadOidcService();
      if (!oidcService) {
        await checkAuth({ silent: true });
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');

      if (code) {
        // OAuth callback - wait for USS OIDC to process and store token
        const checkForToken = () => {
          const storageKey = oidcService.getOidcUserStorageKey();

          if (storageKey) {
            void checkAuth({ silent: true });
          } else {
            setTimeout(checkForToken, 500); // Check again in 500ms
          }
        };

        // Start checking after a brief delay
        setTimeout(checkForToken, 500);
        return;
      }

      // Not a callback - check if already authenticated
      if (oidcService.isStoredTokenExpired()) {
        oidcService.clearOidcSession();
        await oidcService.login();
        return;
      }

      if (oidcService.hasOidcUser()) {
        await checkAuth({ silent: true });
      } else {
        // Keep non-localhost auto-login behavior.
        await oidcService.login();
      }
    };

    void runAuthCheck();
  }, [checkAuth]);

  return (
    <div className="h-full w-full relative">
      <UMapBase>
        <AuthenticatedHeader />
        <div className="relative z-30">
          <ClassMapSidebar />
        </div>
        <MyClassesButton />
        <MyClassesPanel />
        <MyClassesPins />
        <MobileAppControls />
      </UMapBase>
    </div>
  );
}

export default App;
